export default __webpack_public_path__ + "static/media/intro-tab-camera.1597cf92.png";